import type { ReactElement } from "react";
import { NavLink } from "react-router-dom";

interface SidebarProps {
  navItems: {
    path: string;
    title: string;
    icon: ReactElement;
  }[];
  onNavigate?: () => void;
}

export const Sidebar = ({ navItems, onNavigate }: SidebarProps) => {
  return (
    <>
      <div className={`bg-slate-600 text-white w-64 h-full`}>
        <nav className="pt-4">
          <ul>
            {navItems.map(
              (item, index) =>
                item.path && (
                  <li key={index}>
                    <NavLink
                      to={item.path}
                      onClick={onNavigate}
                      className={({ isActive }) =>
                        `flex items-center px-4 py-3 hover:bg-gray-700 transition-colors ${
                          isActive
                            ? "bg-gray-700 border-l-4 border-blue-500"
                            : "border-l-4 border-transparent hover:border-gray-300"
                        }`
                      }
                    >
                      <span className="flex gap-2">
                        {item.icon}
                        {item.title}
                      </span>
                    </NavLink>
                  </li>
                ),
            )}
          </ul>
        </nav>
      </div>
    </>
  );
};
